/**
 * **テーマの一覧**（Issue #523）。**明示の一覧**にしてある（`require.context` は使わない）——
 * 舞台の見た目は数が少なく、並び（画面に出す順）にも意味があるため。
 *
 * テーマを足す ＝ `themes/<name>/` にファイルを置いて、ここに 1 行足す。
 */
import arcade from './arcade';
import climax from './climax';
import plain from './plain';

/** 画面に出す順 */
export const THEMES = Object.freeze([arcade, climax, plain]);

export const DEFAULT_THEME = THEMES[0];

/** 名前で引く（知らない名前は既定のテーマ） */
export const themeByName = (name) => THEMES.find((t) => t.name === name) ?? DEFAULT_THEME;
